import { useQuery } from '@tanstack/react-query';
import { ProjectsResponseType } from '../../types/apiTypes';
import { axiosClient } from '../axiosClient';

const useProjects = (limit = 20) => {
  return useQuery({
    queryKey: ['projects'],
    queryFn: async (): Promise<ProjectsResponseType | null> => {
      const URL = `${import.meta.env.VITE_API_PROJECTS_URL}?limit=${limit}`;

      const { data } = await axiosClient.get<ProjectsResponseType>(URL);
      if (!data) return null;
      return { project_summaries_response: data.project_summaries_response };
    },
  });
};

export default useProjects;
